import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import BackButton from "../../components/BackButton/BackButton";
import { adminGetRiskRuleMapping } from "../../redux/actions/adminRiskRuleMappingAction";
import { adminCreateRiskRuleMapping } from "../../redux/actions/adminCreateRiskRuleMappingAction";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import val from "../../getThemeDetails"
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AdminRiskRuleMapping = () => {
	const [walletOwnerId, setWalletOwnerId] = useState("");
	const [riskGroup, setRiskGroup] = useState("");
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(false);

	const [getRiskRuleMappingStatus, setGetRiskRuleMappingStatus] =
		useState(false);
	const [getRiskRuleMappingArray, setGetRiskRuleMappingArray] = useState([]);

	const [createRiskRuleStatus, setCreateRiskRuleStatus] = useState(false);
	const [createRiskRuleArray, setCreateRiskRuleArray] = useState([]);

	const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);
	const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);

	const [notificationOpen, setNotificationOpen] = React.useState(false);

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const getRiskRuleMappingRes = useSelector(
		({ adminRiskRuleMapping }) => adminRiskRuleMapping
	);

	const createRiskRuleMappingRes = useSelector(
		({ adminCreateRiskRuleMapping }) => adminCreateRiskRuleMapping
	);

	const getWalletOwnerIdRes = useSelector(
		({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
	);

	const handleNoticationClose = () => {
		setWalletOwnerId("Select Owner Id");
		setRiskGroup("Select Risk Group");
		setNotificationOpen(false);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getWalletOwnerIdAndNameListReq();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "walletOwnerId") {
			setWalletOwnerId(value);
		}
		if (name === "riskGroup") {
			setRiskGroup(value == "All" ? "" : value);
		}
	};

	const getRiskRuleMappingReq = () => {
		setIsLoading(true);
		setGetRiskRuleMappingStatus(true);
		let req = {
			partnerId: walletOwnerId == "Select Owner Id" ? "" : walletOwnerId,
			riskGroup: riskGroup == "Select Risk Group" ? "" : riskGroup
		};
		dispatch(adminGetRiskRuleMapping(req, authToken));
	};

	const getRiskRuleMappingFunc = () => {
		if (getRiskRuleMappingStatus) {
			setIsLoading(false);
			if (getRiskRuleMappingRes.data.status == "success") {
				setGetRiskRuleMappingArray(
					[].concat(getRiskRuleMappingRes.data.riskRuleList)
				);
			}
			if (getRiskRuleMappingRes.data.status == "failed") {
				setGetRiskRuleMappingArray(getRiskRuleMappingRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getRiskRuleMappingRes.data.description ||
					getRiskRuleMappingRes.description
				);
				if (
					getRiskRuleMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getRiskRuleMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getRiskRuleMappingRes.data.status == "NOT FOUND") {
				setGetRiskRuleMappingArray(getRiskRuleMappingRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getRiskRuleMappingRes.data.description ||
					getRiskRuleMappingRes.description
				);
			}
		}
	};

	useEffect(() => {
		getRiskRuleMappingFunc();
	}, [getRiskRuleMappingRes.data.status]);

	const createRiskRuleMappingReq = () => {
		setCreateRiskRuleStatus(true);
		let req = {
			loginDetails: {
				walletOwnerId: "1"
			},
			riskRuleList: getRiskRuleMappingArray
		};
		dispatch(adminCreateRiskRuleMapping(req, authToken));
	};

	const createRiskRuleMappingFunc = () => {
		if (createRiskRuleStatus) {
			if (createRiskRuleMappingRes.data.status == "success") {
				setCreateRiskRuleArray(createRiskRuleMappingRes.data);
				getRiskRuleMappingReq();
				setNotificationOpen(true);
			}
			if (createRiskRuleMappingRes.data.status == "failed") {
				setCreateRiskRuleArray(createRiskRuleMappingRes.data);
				getRiskRuleMappingReq();
				setNotificationOpen(true);
				if (
					createRiskRuleMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createRiskRuleMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		createRiskRuleMappingFunc();
	}, [createRiskRuleMappingRes.data.status]);

	var obj = getRiskRuleMappingArray;

	const getCurrIdx = (e, row, type) => {
		const index = obj.findIndex((d) => d.ruleId === row.ruleId);
		if (type == "score") {
			obj[index].riskScore = e.target.value;
		}
		if (type == "limit") {
			obj[index].cardTypeId = e.target.value;
		}
		setGetRiskRuleMappingArray([]);
		setGetRiskRuleMappingArray([].concat(obj));
	};

	const getWalletOwnerIdStatusFunc = () => {
		if (getWalletOwnerIdStatus) {
			if (getWalletOwnerIdRes.data.status == "success") {
				setGetWalletOwnerIdResArray(
					[].concat(getWalletOwnerIdRes.data.ownerList)
				);
			}
			if (getWalletOwnerIdRes.data.status == "failed") {
				setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
				if (
					getWalletOwnerIdRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletOwnerIdRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const getWalletOwnerIdAndNameListReq = () => {
		setGetWalletOwnerIdStatus(true);
		dispatch(
			getWalletOwnerIdAndNameList(
				{
					loginDetails: {
						adminId: val.adminIDS
						// adminId: "2"
					}
				},
				authToken
			)
		);
	};

	// useEffect(() => {
	// 	getWalletOwnerIdAndNameListReq();
	// }, []);

	useEffect(() => {
		getWalletOwnerIdStatusFunc();
	}, [getWalletOwnerIdRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								required
								size="small"
								color="primary"
								type="text"
								label="Owner ID"
								fullWidth={true}
								name="walletOwnerId"
								// value={walletOwnerId || ""}
								defaultValue={"Select Owner Id" || walletOwnerId}
								onChange={handleChange}
							>
								<MenuItem value="Select Owner Id" selected="Select Owner Id">
									Select Owner Id
								</MenuItem>
								{getWalletOwnerIdRes.data.ownerList &&
									getWalletOwnerIdResArray.map((x) => (
										<MenuItem value={x.split("-")[0]}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								// required
								select
								size="small"
								color="primary"
								type="text"
								label="Risk Group"
								fullWidth={true}
								name="riskGroup"
								// value={role || ""}
								defaultValue={"Select Risk Group" || riskGroup}
								onChange={handleChange}
							>
								<MenuItem
									value="Select Risk Group"
									selected="Select Risk Group"
								>
									Select Risk Group
								</MenuItem>
								<MenuItem value="Redeem">Redeem</MenuItem>
								<MenuItem value="Purchase">Purchase</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								variant="contained"
								onClick={getRiskRuleMappingReq}
							>
								Search
							</Button>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getRiskRuleMappingArray.length == undefined ||
					getRiskRuleMappingArray.status == "NOT FOUND" ||
					!getRiskRuleMappingStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"
								
								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
									// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"
								
								>
									Report Table
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table className={classes.table} aria-label="a dense table">
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Rule ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Rule Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Risk Group
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Score
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Limit
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getRiskRuleMappingArray &&
											[]
												.concat(getRiskRuleMappingArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow>
														<TableCell align="center">
															<input
																type="checkbox"
															// key={row.blockId}
															// onChange={(e) => handleChange(row, e)}
															/>
														</TableCell>
														<TableCell align="center">{row.ruleId}</TableCell>
														<TableCell align="center">{row.ruleName}</TableCell>
														<TableCell align="center">
															{row.riskGroup}
														</TableCell>
														<TableCell align="center">
															<TextField
																color="primary"
																type="text"
																value={row.riskScore}
																onChange={(e) => getCurrIdx(e, row, "score")}
															></TextField>
														</TableCell>
														<TableCell align="center">
															<TextField
																color="primary"
																type="text"
																value={row.cardTypeId}
																onChange={(e) => getCurrIdx(e, row, "limit")}
															></TextField>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getRiskRuleMappingArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
								<div className="text-center">
									<Button
										variant="contained"
										style={{
											backgroundColor: "#00b9f5",
											color: "white"
										}}
										size="small"
										className="mb-4 mt-2 px-3 py-2"
										onClick={createRiskRuleMappingReq}
									>
										Save
									</Button>
								</div>
							</TableContainer>
						</Grid>
					</Card>
				)}
			</Layout>

			{createRiskRuleArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createRiskRuleArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{createRiskRuleArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createRiskRuleArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default AdminRiskRuleMapping;